import { useLayoutEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { setDesignerViewLocale } from '@bbkAdminRedux/rtkq/designer-locale.slice';
import { AuthorizedPaths, BASE_PATH } from '@bbkAdminRouter/router-paths';
import { matchPath, useLocation } from '@bbkShared/react-router';

const designerRoutes = [
  { path: AuthorizedPaths.experiencesFunnelsPage, family: 'cancel' },
  {
    path: AuthorizedPaths.experiencesFunnelsPageConfirmation,
    family: 'cancel',
  },
  { path: AuthorizedPaths.cancelPageEditorDrawer, family: 'cancel' },
  { path: AuthorizedPaths.experiencesHostedPage, family: 'hosted' },
];

const getDesignerScope = (pathname: string) => {
  for (const { path, family } of designerRoutes) {
    const match = matchPath(`${BASE_PATH}${path}`, pathname);
    if (match) {
      const { companyId, appId, funnelId } = match.params;
      return JSON.stringify([family, companyId, appId, funnelId]);
    }
  }
  return undefined;
};

/** Keep locale ownership across page remounts, but only within one designer. */
export const DesignerLocaleRouteObserver = () => {
  const { pathname } = useLocation();
  const dispatch = useDispatch();
  const scope = getDesignerScope(pathname);
  const previousScope = useRef(scope);

  useLayoutEffect(() => {
    const previous = previousScope.current;
    previousScope.current = scope;
    if (previous !== undefined && previous !== scope) {
      dispatch(setDesignerViewLocale(undefined));
    }
  }, [dispatch, scope]);

  return null;
};
